import {normalizeSpecialCharacters} from './string-util';

export const COMPARERS = {
	'EQUALS': 'eq',
	'CONTAINS': 'in',
	'LESS_THAN': 'lt',
	'LESS_THAN_OR_EQUAL': 'lte',
	'GREATER_THAN': 'gt',
	'GREATER_THAN_OR_EQUAL': 'gte',
	'REGULAR_EXPRESION': 'regEx',
	'STARTS_WITH': 'sw',
	'ENDS_WITH': 'ew'
};

export function isConditionActive(condition, compareAgainst) {
	const {
		comparer = COMPARERS.EQUALS,
		value,
		normalized = false
	} = condition;

	if (comparer.indexOf('!') === 0) {
		return !isConditionActive({
			...condition,
			'comparer': comparer.slice(1)
		}, compareAgainst);
	}

	let fieldValue = compareAgainst;

	if (normalized) {
		if (typeof fieldValue === 'string') {
			fieldValue = normalizeSpecialCharacters(fieldValue);
		} else if (Array.isArray(fieldValue)) {
			fieldValue = fieldValue.map(normalizeSpecialCharacters);
		}
	}

	if (typeof fieldValue === 'undefined' || fieldValue === null) {
		return false;
	}

	if (comparer === COMPARERS.EQUALS) {
		return _equals(fieldValue, value);
	}

	if (comparer === COMPARERS.CONTAINS) {
		return _contains(fieldValue, value);
	}

	if (comparer === COMPARERS.LESS_THAN || comparer === COMPARERS.LESS_THAN_OR_EQUAL
		|| comparer === COMPARERS.GREATER_THAN || comparer === COMPARERS.GREATER_THAN_OR_EQUAL) {
		return _quantitativeCompare(comparer, fieldValue, value);
	}

	if (comparer === COMPARERS.REGULAR_EXPRESION) {
		return _regexCompare(fieldValue, value);
	}

	if (comparer === COMPARERS.ENDS_WITH) {
		return _endsWithCompare(fieldValue, value);
	}

	if (comparer === COMPARERS.STARTS_WITH) {
		return _startsWithCompare(fieldValue, value);
	}

	throw new Error(`Unknown comparer '${comparer}' for conditional configuration`);
}

function _equals(fieldValue, value) {
	return JSON.stringify(fieldValue) === JSON.stringify(value);
}

function _contains(fieldValue, value) {
	if (value && Array.isArray(value)) {
		return value.every((val) => _contains(fieldValue, val));
	}

	return fieldValue.indexOf(value) !== -1;
}

function _quantitativeCompare(comparer, fieldValue, value) {
	if (typeof fieldValue !== 'number') {
		fieldValue = parseFloat(fieldValue);
	}

	if (isNaN(fieldValue)) {
		return false;
	}

	switch (comparer) {
		case COMPARERS.LESS_THAN:
			return fieldValue < value;

		case COMPARERS.LESS_THAN_OR_EQUAL:
			return fieldValue <= value;

		case COMPARERS.GREATER_THAN:
			return fieldValue > value;

		case COMPARERS.GREATER_THAN_OR_EQUAL:
			return fieldValue >= value;
	}
}

function _regexCompare(fieldValue, value) {
	if (fieldValue && Array.isArray(fieldValue)) {
		return fieldValue.every((val) => _regexCompare(val, value));
	}

	const regex = new RegExp(value);

	return regex.test(fieldValue);
}

function _startsWithCompare(fieldValue, value) {
	if (fieldValue && Array.isArray(fieldValue)) {
		if (fieldValue.length > 0) {
			return fieldValue[0] === value;
		}

		return false;
	}

	return fieldValue.startsWith(value);
}

function _endsWithCompare(fieldValue, value) {
	if (fieldValue && Array.isArray(fieldValue)) {
		if (fieldValue.length > 0) {
			return fieldValue[fieldValue.length - 1] === value;
		}

		return false;
	}

	return fieldValue.endsWith(value);
}

export default {
	isConditionActive,
	COMPARERS
};
